import urls from '@/networkRequests/apiClient/endpoints'

import { configureRequest } from '../../../../../networkRequests/apiClient/apiClient.functions'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  GetAllOfferRequestsForAdminErrorResponse,
  GetAllOfferRequestsForAdminRequest,
  GetAllOfferRequestsForAdminSuccessResponse
} from './getAllOfferRequestsForAdmin.types'

export const getAllOfferRequestsForAdminApi = async (
  request: GetAllOfferRequestsForAdminRequest
): Promise<GetAllOfferRequestsForAdminSuccessResponse> => {
  const { page, size, searchQuery } = request

  const response = await configureRequest({
    url: urls.admin.getAllOfferRequestsForAdmin,
    method: 'GET',
    params: {
      page,
      size,
      ...(searchQuery ? { searchQuery } : {})
    },
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetAllOfferRequestsForAdminSuccessResponse
  } else {
    throw response as GetAllOfferRequestsForAdminErrorResponse
  }
}

export default getAllOfferRequestsForAdminApi
